"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeRange = void 0;

var _Time = require("./Time");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TimeRange = /*#__PURE__*/function () {
  /**
   * Creates an instance of TimeRange.
   *
   * @param {Time} start
   * @param {Time} end
   * @memberof TimeRange
   */
  function TimeRange(start, end) {
    _classCallCheck(this, TimeRange);

    this._start = start;
    this._end = end;
  }
  /**
   * The start time of this range
   * @readonly
   * @memberof TimeRange
   */


  _createClass(TimeRange, [{
    key: "start",
    get: function get() {
      return this._start;
    }
    /**
     * The end time of this range
     * @readonly
     * @memberof TimeRange
     */

  }, {
    key: "end",
    get: function get() {
      return this._end;
    }
    /**
     * the duration of this range in milliseconds
     * @readonly
     * @memberof TimeRange
     */

  }, {
    key: "duration",
    get: function get() {
      return this._end._utc - this._start._utc;
    }
    /**
     * the duration of this range in milliseconds
     * @readonly
     * @memberof TimeRange
     */

  }, {
    key: "durationSeconds",
    get: function get() {
      return (this._end._utc - this._start._utc) / 1000;
    }
    /**
     * does the given time fall within this range
     *
     * @param {Time|number} time - Time object or milliseconds in UTC
     * @return {boolean}
     * @memberof TimeRange
     */

  }, {
    key: "includes",
    value: function includes(time) {
      var check = 0;
      var end = 0;
      var start = 0;

      if (time instanceof _Time.Time) {
        check = time.utc;
        start = this._start.utc;
        end = this._end.utc;
      } else if (typeof time === "number") {
        check = time;
        start = this._start.utc;
        end = this._end.utc;
      } // hack for inprecise floating point math


      if (this.fuzz) {
        start -= this.fuzz;
        end += this.fuzz;
      }

      return start <= check && check <= end;
    }
    /**
     * does the given time fall within this range: alias for includes
     *
     * @param {Time|number} time - Time object or milliseconds in UTC
     * @return {boolean}
     * @memberof TimeRange
     */

  }, {
    key: "contains",
    value: function contains(time) {
      return this.includes(time);
    }
  }], [{
    key: "from",
    value:
    /**
     * create a new TimeRange object with start and end time objects
     *
     * @static
     * @param {Time} start
     * @param {Time} end
     * @return {TimeRange}
     * @memberof TimeRange
     */
    function from(start, end) {
      return new TimeRange(start, end);
    }
    /**
     * create a new TimeRange object with start time and duration
     *
     * @static
     * @param {Time} start
     * @param {number} dur - duration in milliseconds
     * @return {TimeRange}
     * @memberof TimeRange
     */

  }, {
    key: "fromDuration",
    value: function fromDuration(start, dur) {
      var end = new _Time.Time(start._utc + dur, 0);
      return new TimeRange(start, end);
    }
    /**
     * create a new TimeRange object with ms utc start and end times
     *
     * @static
     * @param {number} start - milliseconds in UTC
     * @param {number} end - milliseconds in UTC
     * @return {TimeRange}
     * @memberof TimeRange
     */

  }, {
    key: "fromUTC",
    value: function fromUTC(start, end) {
      var st = new _Time.Time(start, 0);
      var et = new _Time.Time(end, 0);
      return this.from(st, et);
    }
    /**
     * create a new TimeRange object with ms utc start and ms duration
     *
     * @static
     * @param {number} start - milliseconds in UTC
     * @param {number} dur - duration in milliseconds
     * @return {TimeRange}
     * @memberof TimeRange
     */

  }, {
    key: "fromUTCDuration",
    value: function fromUTCDuration(start, dur) {
      var st = new _Time.Time(start, 0);
      return this.fromDuration(st, dur);
    }
    /**
     * create a new TimeRange object from a moment shaped object
     *
     * @static
     * @param {Moment} moment - graphql moment object
     * @return {TimeRange}
     * @memberof TimeRange
     */

  }, {
    key: "fromMoment",
    value: function fromMoment(moment) {
      var start = _Time.Time.fromMilliseconds(moment.start_time, 0);

      var end = _Time.Time.fromMilliseconds(moment.start_time + moment.duration * 1000, 0);

      return this.from(start, end);
    }
  }]);

  return TimeRange;
}();

exports.TimeRange = TimeRange;